import BlockDetail from './BlockDetail';
import BlockList from './BlockList';

const routes = [
  {
    path: '',
    element: <BlockList />,
  },
  {
    path: ':number',
    element: <BlockDetail />,
  },
];

export default routes;
